// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","aside":"Navbar_aside__X4kXV"};